export * from './groupType.service';
import { GroupTypeService } from './groupType.service';
export * from './invoiceImages.service';
import { InvoiceImagesService } from './invoiceImages.service';
export * from './language.service';
import { LanguageService } from './language.service';
export * from './licence.service';
import { LicenceService } from './licence.service';
export * from './lockedRow.service';
import { LockedRowService } from './lockedRow.service';
export * from './objectType.service';
import { ObjectTypeService } from './objectType.service';
export const APIS = [GroupTypeService, InvoiceImagesService, LanguageService, LicenceService, LockedRowService, ObjectTypeService];
